import React from "react";
import {GalleryDefault, GalleryMasonry, GalleryQuilted, GalleryWoven} from "./gallery";

function CustomGallery({variant, data}) {
    return (
        <>
            {variant === "default" && <GalleryDefault data={data} />}
            {variant === "masonry" && <GalleryMasonry data={data} />}
            {variant === "quilted" && <GalleryQuilted data={data} />}
            {variant === "woven" && <GalleryWoven data={data} />}
        </>
    );
}

export default CustomGallery;
